export default "__VITE_ASSET__B5gcV033__"